import React from 'react'
import PropTypes from 'prop-types'

import ToggleableSection from 'components/ToggleableSection'
import { getSegmentValue } from 'components/SegmentSelector/segment-service'
import ClassYearSelector, { SegmentName, Criteria } from '../components/ClassYearSelector'
import { withContext } from '../Context'

export const GraduationYearSelector = ({ segment, onChange, onError }) => {
  const currentValues = getSegmentValue(segment, Criteria, SegmentName)
  const hasError = !currentValues || !currentValues.length
  if (onError) {
    onError('GraduationYearSelector', hasError)
  }

  return (
    <ToggleableSection
      title="Class Year"
      info="The current academic year of a student’s graduating class"
      hasError={!currentValues || !currentValues.length}
    >
      <ClassYearSelector
        years={currentValues}
        onChange={(years) => onChange(Criteria, SegmentName, years)}
      />
    </ToggleableSection>
  )
}

GraduationYearSelector.propTypes = {
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
}

export default withContext(GraduationYearSelector)
